import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InvestmentDetailComponent } from 'src/app/pages/investment-detail/investment-detail.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [

  {
    path: '',
    component: InvestmentDetailComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class InvestmentsRoutingModule { }
